/**
 * Supabase Client Initializer & Singleton
 */
import { createClient } from '@supabase/supabase-js';

// Environment variables provided by Vite or fallback to runtime localStorage
const envUrl = import.meta.env.VITE_SUPABASE_URL || '';
const envKey = import.meta.env.VITE_SUPABASE_ANON_KEY || '';

const storedUrl = typeof localStorage !== 'undefined' ? localStorage.getItem('funshine_supabase_url') : null;
const storedKey = typeof localStorage !== 'undefined' ? localStorage.getItem('funshine_supabase_key') : null;

export const SUPABASE_URL = storedUrl || envUrl;
export const SUPABASE_ANON_KEY = storedKey || envKey;

export const isSupabaseConfigured = () => {
  return (
    Boolean(SUPABASE_URL) &&
    Boolean(SUPABASE_ANON_KEY) &&
    !SUPABASE_URL.includes('your-project-ref') &&
    !SUPABASE_ANON_KEY.includes('your-anon-publishable-key')
  );
};

let clientInstance = null;

if (isSupabaseConfigured()) {
  try {
    clientInstance = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
        storageKey: 'funshine-auth-token'
      },
      realtime: {
        params: {
          eventsPerSecond: 10
        }
      }
    });
  } catch (err) {
    console.warn('[Supabase] Failed to initialize client:', err);
  }
}

export const supabase = clientInstance;

/**
 * Configure credentials dynamically from UI if not set in environment
 */
export function setCustomCredentials(url, key) {
  if (url && key) {
    localStorage.setItem('funshine_supabase_url', url.trim());
    localStorage.setItem('funshine_supabase_key', key.trim());
    window.location.reload();
  }
}

export function clearCustomCredentials() {
  localStorage.removeItem('funshine_supabase_url');
  localStorage.removeItem('funshine_supabase_key');
  window.location.reload();
}
